module.exports = __webpack_public_path__ + "img/2.7f4097ed.png";